import React from "react";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Values from "@/components/site/Values";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import Gallery from "@/components/site/Gallery";
import Stats from "@/components/site/Stats";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";

const HomePage = () => {
  return (
    <div className="bg-[#0a0a0b] text-neutral-100 min-h-screen">
      <Header />
      <main>
        <Hero />
        <Values />
        <About />
        <Services />
        <Portfolio />
        <Gallery />
        <Stats />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141415",
            color: "#f3f4f6",
            border: "1px solid #262626",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
};

export default HomePage;
